module.exports = __webpack_public_path__ + "img/labmemtest_text_btn01_tc.19059422.png";